module.exports = __webpack_public_path__ + "img/mountains.d9ade356.jpg";